<template>
  <div>
    <v-tooltip bottom>
      <span slot="activator">
        <v-btn small icon @click.stop="handleShowClick">
          <v-icon small>fa-edit</v-icon>
        </v-btn>
      </span>
      Edit services
    </v-tooltip>

    <v-dialog v-model="showModal" full-width @input="$emit('refreshData')">
      <v-card v-if="showModal">
        <v-card-title><h1>Case services of {{caseTitleFull}}</h1></v-card-title>
        <v-card-text>
          <case-service-log :case-id="caseId"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import CaseServiceLog  from "./CaseServiceLog";

    export default {
        name: 'modal-case-service-log',
        components: {
            CaseServiceLog
        },
        props: {
            caseId: {
                type: String,
                required: true
            },
            caseTitle: {
                type: String,
            }
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            handleShowClick() {
                this.showModal = true
            }
        },
        computed: {
            caseTitleFull() {
                if (this.caseTitle) {
                    return this.caseTitle
                } else {
                    return this.caseId
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/ModalCaseServiceLog.vue